
var loadAnnouncements = function(url) {
  var url = url ? url : '/announcements';
  Kadenze.UIUtil.showLoadingIndicator($('#announcement-listing'), null, true);
  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json',
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    }
  }).success(function(data) {
    $('#paginator').html(data.paginator);
    $('#announcement-listing').hide().html(data.course_listing).fadeIn('slow');
    bindAnnouncementListing();
  }).error(function(data) {
    console.warn('error retrieving announcement data');
    console.log(data);
  }).always(function(data){
    Kadenze.UIUtil.hideLoadingIndicator($('#announcement-listing'));
  });
};

var bindAnnouncementListing = function() {
  console.log('binding bindAnnouncementListing');
  $('.pagination a').on('click', function() {
    var url = $(this).attr('href');
    if (url != '#') {
      loadAnnouncements(url);
    }
    return false;
  });
};

export default {
  init: function() {
    bindAnnouncementListing();
  }
};

